import axios from 'axios'
import {logger} from 'src/common/logger'

const LOG_SOURCE = 'moss-api'

const getPathWithoutQueryString = (url: string | undefined): string | undefined => url?.split('?')[0]

// Logs only method, path, status and code. The error, its config, bodies and query strings can hold personal data.
export const logApiError = (error: unknown): Promise<never> => {
  if (axios.isCancel(error)) {
    return Promise.reject(error)
  }

  if (axios.isAxiosError(error)) {
    logger.error('Moss API request failed', {
      context: LOG_SOURCE,
      method: error.config?.method?.toUpperCase(),
      path: getPathWithoutQueryString(error.config?.url),
      httpStatus: error.response?.status,
      errorCode: error.code,
    })
  } else {
    logger.error('Moss API request failed with an unexpected error', {context: LOG_SOURCE})
  }

  return Promise.reject(error)
}
